import { useNavigate } from "react-router-dom";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { StatusBadge } from "@/components/common/StatusBadge";
import { EmptyState } from "@/components/shell/DashboardShell";
import { REQUEST_TYPES } from "@/data/portal";
import { fmtDate } from "@/lib/api";

export const RequestTable = ({ rows, basePath, onRowClick, showCompany = false }) => {
  const navigate = useNavigate();
  if (!rows.length) return <EmptyState title="No requests yet" text="Requests you raise will appear here with live status." testid="requests-empty" />;
  return (
    <div className="card-base overflow-x-auto" data-testid="requests-table">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Reference</TableHead>
            {showCompany && <TableHead>Company</TableHead>}
            <TableHead>Type</TableHead>
            <TableHead>Subject</TableHead>
            <TableHead>Priority</TableHead>
            <TableHead>Raised</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id} className="cursor-pointer" onClick={() => (onRowClick ? onRowClick(r) : navigate(`${basePath}/${r.id}`))} data-testid={`request-row-${r.reference}`}>
              <TableCell className="mono text-xs font-semibold">{r.reference}</TableCell>
              {showCompany && <TableCell className="font-medium">{r.company_name}</TableCell>}
              <TableCell className="whitespace-nowrap text-sm">{REQUEST_TYPES[r.type]?.label}</TableCell>
              <TableCell className="max-w-[260px] truncate text-sm">{r.subject}</TableCell>
              <TableCell className={`text-xs font-semibold uppercase ${r.priority === "urgent" ? "text-[#C20500]" : r.priority === "high" ? "text-amber-600" : "text-slate-500"}`}>{r.priority}</TableCell>
              <TableCell className="whitespace-nowrap text-sm text-slate-500">{fmtDate(r.created_at)}</TableCell>
              <TableCell><StatusBadge status={r.status} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
